import { RouteConfig } from "vue-router/types/router";

export const exampleRoutes = (startTemplate: string): RouteConfig[] => [
    {
        path: startTemplate + '/example',
        name: 'example',
        component: () => import(/* webpackChunkName: "example" */ '../../views/example/ExampleView.vue')
    }
]
